<template>
  <div class="component component--fullscreen" v-if="visable">
    <transition name="overlay">
      <div class="component__overlay" v-if="componentVisible"></div>
    </transition>
    <transition name="notification">
      <div class="component__containter" v-if="componentVisible" ref="containter">
        <div class="notification-list" v-body-scroll-lock="componentVisible">
          <div class="notification-item"
            v-for="notification in notifications"
            v-on:click="clickNotification(notification)"
            :key="notification._id.$id"
            :class="{
              'is-new': notification.checked === 0,
              'is-news' : notification.action === 'news',
              'is-link' : notification.action === 'url',
              'is-vip_change': notification.action === 'vip_change',
            }">
            <div class="row no-gutters align-items-center">
              <div class="col">
                <div class="content">{{ notification.msg }}</div>
                <div class="timestamp">{{ notification.create_time | moment('calendar', null, { sameElse: 'l LT' }) }}</div>
              </div>
              <div class="col-auto chevron"><i class="material-icons">launch</i></div>
              <!-- <div class="col col-auto align-self-center">
                <div class="new" v-if="notification.checked === 0">N</div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Axios from '@/helpers/axios';

export default {
  name: 'Notification',
  props: {
    visable: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      componentVisible: false,
      notifications: {},
    };
  },
  watch: {
    visable(value) {
      this.$nextTick(() => {
        this.componentVisible = value;
      });
    },
    componentVisible(value) {
      if (value) {
        const data = {
          lang: this.$i18n.locale,
          p: this.$parent.client.phoneType,
          brand_id: this.$route.params.brand,
          dtk: this.$parent.client.dtk,
        };

        Axios({
          method: 'post',
          url: '/Notice/GetMyNotice',
          data,
        })
          .then((response) => {
            if (response.data.code === 500) {
              this.notifications = response.data.data;
              this.$refs.containter.style.right = `${window.innerWidth - this.$parent.$refs.notificationBtn.getBoundingClientRect().right - 15}px`;
              // this.$refs.containter.style.left = 'auto';
            }
          });

        this.$gtm.trackEvent({
          event: '查看通知',
          label: `${this.$root.$store.state.brand.name}`,
        });
      } else {
        this.$emit('clearNotificationBadge');
      }
    },
  },
  methods: {
    clickNotification(notification) {
      const query = Object.assign({}, this.$route.query);

      switch (notification.action) {
        case 'news':
          this.$router.push({ name: 'News', params: { token: notification.news_id }, query });
          break;

        case 'url':
          this.$gtm.trackEvent({
            event: '通知 - 查看 URL',
            label: `${this.$root.$store.state.brand.name} - ${notification.target}`,
          });

          window.open(notification.target, '_blank');
          break;

        case 'vip_change':
          this.$emit('closeNotification');
          this.$router.push({ name: 'Index' });
          break;

        default:
          break;
      }
    },
  },
};
</script>

<style lang="sass" scoped>
.component--fullscreen
  position: fixed
  top: 0
  right: 0
  bottom: 0
  left: 0
  z-index: 1040

  transition: all .25s ease

.component__overlay
  position: fixed
  top: 0
  right: 0
  bottom: 0
  left: 0
  z-index: 1040
  opacity: .7

  background-image: linear-gradient(0deg, rgba(44,43,43,0.95) 0%, rgba(33,32,32,0.95) 100%)

.component__containter
  position: fixed
  top: 54px
  right: 0
  bottom: 0
  left: 0
  z-index: 1050
  margin: 0 auto

  background-color: white

  border-radius: 12px

  @media only screen and (min-width : 768px)
    left: auto
    max-width: 475px
    max-height: 500px

  &::before
    position: absolute
    top: -6px
    right: 20px
    width: 0
    height: 0
    border-style: solid
    border-width: 0 5.5px 6px 5.5px
    border-color: transparent transparent white transparent

    content: ''

.notification
  &-list
    height: 100%
    padding: 15px
    overflow: hidden
    overflow-y: auto
    -webkit-overflow-scrolling: touch

  &-item
    padding: 12px 10px

    &.is-news,
    &.is-link,
    &.is-vip_change
      cursor: pointer

      .chevron
        display: block

    &:not(:last-child)
      border-bottom: .5px solid #C4C4C4

.content
  font-size: 0.916rem

.new
  padding: 0 4px

  border-radius: 8px

  background-color: #FD0000

  font-weight: bold
  font-size: 0.75rem
  color: white

.content
  margin-bottom: 4px

  line-height: 1.2
  font-weight: bold

.timestamp
  font-size: 0.75rem
  color: #999

.chevron
  display: none

  color: #aaa

.overlay-enter-active,
.overlay-leave-active
  transition: opacity .25s cubic-bezier(.4, 0, .2, 1)

.overlay-enter,
.overlay-leave-to
  opacity: 0

.notification-enter-active,
.notification-leave-active
  transition: opacity .25s cubic-bezier(.4, 0, .2, 1), transform .15s cubic-bezier(.4, 0, .2, 1)
  transition-delay: .15s
  transform-origin: calc(100% - 28px) -27px

.notification-enter,
.notification-leave-to
  opacity: 0
  transform: scale(0, 0)
</style>
